import { Reveal, Overline } from "../components/Reveal";

export const IntelligentFootballers = () => (
  <section id="why-zavi" className="py-24 sm:py-32 scroll-mt-16 bg-[#050505]" data-testid="intelligent-section">
    <div className="max-w-6xl mx-auto px-6 lg:px-12">
      <Reveal>
        <Overline>Our Philosophy</Overline>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight leading-[1.05] max-w-4xl mt-3" data-testid="intelligent-headline">
          We don't coach players<br className="hidden sm:block" /> to wait for <span className="text-[#D4AF37]">instructions.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mt-6 text-white/80 text-base sm:text-lg max-w-3xl leading-relaxed">
          We develop players who <span className="text-white font-semibold">see the game, make decisions and act for themselves.</span>
        </p>
      </Reveal>
      <div className="mt-12 grid md:grid-cols-2 gap-8 max-w-4xl">
        <Reveal delay={0.25}>
          <p className="text-white/60 text-[15px] leading-relaxed" data-testid="intelligent-body-1">
            Football is unpredictable. Players cannot rely on a coach shouting instructions from the sideline. Our training environments constantly challenge players to scan, think, solve problems and make decisions under pressure.
          </p>
        </Reveal>
        <Reveal delay={0.35}>
          <p className="text-white/60 text-[15px] leading-relaxed" data-testid="intelligent-body-2">
            The objective is not to create coach-dependent players. It is to develop <span className="text-[#D4AF37] font-semibold">intelligent, independent footballers</span> who take ownership of the game they play.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
